import React, { useState } from 'react';
import { Box, Typography, List, ListItem, ListItemButton, ListItemText, Collapse, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PeopleIcon from '@mui/icons-material/People';

const SubmenuContainer = styled(Box)(({ theme }) => ({
  width: 200,
  height: '100vh',
  backgroundColor: '#F7FAFC',
  display: 'flex',
  flexDirection: 'column',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  position: 'fixed',
  left: 80, // Position it right after the main sidebar
  top: 0,
  zIndex: 999,
  borderRight: '1px solid #E2E8F0',
}));

const PeopleSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  borderBottom: '1px solid #E2E8F0',
  marginBottom: theme.spacing(2),
}));

const PeopleHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));

const PeopleTitle = styled(Typography)(({ theme }) => ({
  fontSize: '1.1rem',
  fontWeight: 600,
  color: '#1A202C',
}));

const SubmenuItem = styled(ListItemButton)<{ active?: string }>(({ theme, active }) => ({
  padding: theme.spacing(1, 2),
  margin: theme.spacing(0.5, 1),
  borderRadius: 6,
  backgroundColor: active === "true" ? '#6B46C1' : 'transparent',
  color: active === "true" ? '#FFFFFF' : '#4A5568',
  '&:hover': {
    backgroundColor: active === "true" ? '#6B46C1' : '#EDF2F7',
  },
  '& .MuiListItemText-primary': {
    fontSize: '0.9rem',
    fontWeight: active === "true" ? 600 : 500,
  },
}));

const PeopleSubmenu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [peopleOpen, setPeopleOpen] = useState(true);

  const peopleSubmenuItems = [
    { label: 'Manage Users', path: '/users', active: location.pathname === '/users' },
    { label: 'Manage Companies', path: '/companies', active: location.pathname === '/companies' },
    { label: 'Impersonate User', path: '/impersonate', active: location.pathname === '/impersonate' },
    { label: 'Role & Permission Editor', path: '/roles', active: location.pathname === '/roles' },
  ];

  return (
    <SubmenuContainer>
      <PeopleSection>
        <PeopleHeader>
          <PeopleIcon sx={{ color: '#6B46C1', fontSize: 24 }} />
          <PeopleTitle>People</PeopleTitle>
          <IconButton
            size="small"
            onClick={() => setPeopleOpen(!peopleOpen)}
            sx={{ marginLeft: 'auto', color: '#6B46C1' }}
          >
            {peopleOpen ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </PeopleHeader>
        
        <Collapse in={peopleOpen} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {peopleSubmenuItems.map((item, index) => (
              <ListItem key={index} disablePadding>
                <SubmenuItem
                  active={item.active ? "true" : "false"}
                  onClick={() => navigate(item.path)}
                >
                  <ListItemText primary={item.label} />
                </SubmenuItem>
              </ListItem>
            ))}
          </List>
        </Collapse>
      </PeopleSection>
    </SubmenuContainer>
  );
};

export default PeopleSubmenu; 